export const NEWS_API_URL = process.env.REACT_APP_NEWS_API_URL;
export const ENQUIRY_URL = process.env.REACT_APP_PUBLIC_FORM_URL;

// Sampradaya and PU College forms are hosted separately from the school form.
const ADMIN_FORM_BASE_URL = (
  process.env.REACT_APP_ADMIN_FORM_BASE_URL || ""
).replace(/\/$/, "");
export const SAMPRADAYA_ENQUIRY_URL = `${ADMIN_FORM_BASE_URL}/public/sampradaya`;
export const PU_ENQUIRY_URL = `${ADMIN_FORM_BASE_URL}/public/svvk-enquiry`;

// Shared by the header's "Admission Enquiry" menu and the general apply CTAs.
export const ADMISSION_ITEMS = [
  { label: "School", href: ENQUIRY_URL },
  { label: "Sampradaya (SAEM)", href: SAMPRADAYA_ENQUIRY_URL },
  { label: "PU College", href: PU_ENQUIRY_URL },
];
